import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function AutoLock({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M12.3899 7V12.39H7.98993M20.9399 11C20.3799 6.06 15.9299 2.5 10.9899 3.05C6.04993 3.6 2.48993 8.05 3.03993 12.99C3.49993 17.16 6.79993 20.46 10.9799 20.93M17.2499 18H20.7499M17.2499 18C16.5596 18 15.9999 18.5596 15.9999 19.25V20.75C15.9999 21.4404 16.5596 22 17.2499 22H20.7499C21.4403 22 21.9999 21.4404 21.9999 20.75V19.25C21.9999 18.5596 21.4403 18 20.7499 18M17.2499 18V16.75C17.2499 15.78 18.0299 15 18.9999 15C19.9599 15 20.7499 15.78 20.7499 16.75V18" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default AutoLock;